<ion-list>
  <div *ngIf="_ascents; else loading ">
    <ion-list-header>
      <ion-label>
        <b>
          {{_ascents.length}} {{(_ascents.length == 1 ? "ascent-list-component.ascent" : "ascent-list-component.ascents") | translate}}
          <span *ngIf="numFlashed>0">
            ({{numFlashed}} {{(numFlashed == 1 ? "ascent-list-component.flash" : "ascent-list-component.flashs") | translate}}
            )
        </span>
        </b>
      </ion-label>
    </ion-list-header>
    <ion-item *ngFor="let ascent of _ascents | newestFirst" (click)="ascentClicked(ascent)">
      <ion-icon *ngIf="!ascent.flash" color="yellow" name="checkmark" size="small" slot="start"></ion-icon>
      <ion-icon *ngIf="ascent.flash" color="yellow" name="flash" size="small" slot="start"></ion-icon>
      <ion-label>
        <b>{{ascent.userName}}</b>
        <ion-chip class="mini-chip grade-chip"
                  *ngIf="ascent.personalGrade">{{ascent.personalGrade | boulderGrade}}</ion-chip>
      </ion-label>
      <ion-note slot="end">{{ascent.date|dateFormat}}</ion-note>
    </ion-item>
  </div>
  <ng-template #loading>{{"ascent-list-component.loading-ascents" | translate}}</ng-template>
</ion-list>
